import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ButtonBase from '$app-web/ui-kit/components/button-base';

import { CATEGORY_TYPES } from '../../constants';
import classes from './styles.module.scss';

const Categories = (props) => {
    const { currentCategory, onChange } = props;

    const { t } = useTranslation();

    return (
        <div className={clsx('flex align-center justify-center content-center', classes.root)}>
            <ButtonBase
                className={clsx('item typo-old body2', classes.title, currentCategory === CATEGORY_TYPES.ALL && classes.selected)}
                onClick={() => onChange(CATEGORY_TYPES.ALL)}
            >
                {t('all')}
            </ButtonBase>
            <ButtonBase
                className={clsx(
                    'item typo-old body2',
                    classes.title,
                    currentCategory === CATEGORY_TYPES.DIRECT && classes.selected
                )}
                onClick={() => onChange(CATEGORY_TYPES.DIRECT)}
            >
                {t('directs')}
            </ButtonBase>
            <ButtonBase
                className={clsx(
                    'item typo-old body2',
                    classes.title,
                    currentCategory === CATEGORY_TYPES.GROUP && classes.selected
                )}
                onClick={() => onChange(CATEGORY_TYPES.GROUP)}
            >
                {t('groups')}
            </ButtonBase>
        </div>
    );
};

Categories.propTypes = {
    currentCategory: PropTypes.oneOf(Object.values(CATEGORY_TYPES)).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Categories;
